"use client";

import { useTranslations } from "next-intl";
import { useSession } from "@/hooks/use-session";

/** Shown when the Convex user query has been stalled for >20s: the network
 *  path to the backend is degraded but the session itself is still valid.
 *  Replaces the old behaviour of silently logging the user out. */
export function ConnectionBanner() {
  const { connectionStalled } = useSession();
  const t = useTranslations("common");

  if (!connectionStalled) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-[100] flex justify-center px-4">
      <div className="flex max-w-md items-center gap-3 rounded-xl border border-amber-500/30 bg-surface px-4 py-3 text-ink shadow-lg light:shadow-md">
        <WifiOffIcon />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">{t("connectionLostTitle")}</p>
          <p className="mt-0.5 text-xs leading-snug text-ink-mute">
            {t("connectionLostHint")}
          </p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="shrink-0 rounded-lg bg-surface-mute px-3 py-1.5 text-xs font-medium text-ink transition-colors hover:bg-amber-500/20"
        >
          {t("retry")}
        </button>
      </div>
    </div>
  );
}

function WifiOffIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="shrink-0 text-amber-500"
    >
      <path d="M12 20h.01" />
      <path d="M8.5 16.5a5 5 0 0 1 7 0" />
      <path d="M5 13a10 10 0 0 1 5.24-2.76" />
      <path d="M13.8 10.2A10 10 0 0 1 19 13" />
      <path d="M2 9.5a15 15 0 0 1 4.18-2.94" />
      <path d="M10.7 5.05A15 15 0 0 1 22 9.5" />
      <path d="M2 2l20 20" />
    </svg>
  );
}
